import type { StatusColor } from '@ztechapps/common.contract'
import { StatusToneEnum } from '@ztechapps/common.contract'

/** What a status paints with: its fill and the text colour that reads on it. */
export type ResolvedStatusColor = { fill: string; text: string }

// Each fill is a custom property declared in ./StatusColor.scss.
const STATUS_TONE_COLORS: Record<StatusToneEnum, ResolvedStatusColor> = {
  [StatusToneEnum.Draft]: { fill: 'var(--status-tone-draft)', text: 'var(--bs-white)' },
  [StatusToneEnum.Active]: { fill: 'var(--status-tone-active)', text: 'var(--bs-white)' },
  [StatusToneEnum.InProgress]: { fill: 'var(--status-tone-in-progress)', text: 'var(--bs-white)' },
  [StatusToneEnum.Inactive]: { fill: 'var(--status-tone-inactive)', text: 'var(--bs-body-bg)' },
  [StatusToneEnum.Cancelled]: { fill: 'var(--status-tone-cancelled)', text: 'var(--bs-body-bg)' },
  [StatusToneEnum.Failure]: { fill: 'var(--status-tone-failure)', text: 'var(--bs-white)' },
}

/**
 * Every status colour carries a fixed text colour: several fills change with the theme, and StatusBadge's runtime
 * pick re-measures only when its fill string changes. Every custom colour carries white text in both themes.
 */
export const resolveStatusColor = (statusColor?: StatusColor): ResolvedStatusColor | undefined => {
  if (!statusColor) return undefined
  return 'tone' in statusColor
    ? STATUS_TONE_COLORS[statusColor.tone]
    : { fill: statusColor.color, text: 'var(--bs-white)' }
}
